var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "el-section" },
        [_c("invite-detail-grid", { attrs: { invite: _vm.invite } })],
        1
      ),
      _c(
        "div",
        { staticClass: "el-section" },
        [
          _c(
            "emd-card",
            [
              _c(
                "emd-card-header",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "actions",
                      fn: function () {
                        return [
                          _vm.showActionsButton
                            ? _c(
                                "div",
                                {
                                  staticClass: "emd-dropdown _position_right",
                                  attrs: { id: "jsDropdown" },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "emd-dropdown__trigger" },
                                    [
                                      _c(
                                        "emd-button",
                                        {
                                          attrs: {
                                            color: "primary",
                                            size: "small",
                                          },
                                          on: { click: _vm.toogleDropdown },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "users.detail.actions.title"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "emd-dropdown__content",
                                      class: {
                                        _active: _vm.showActionsDropdown,
                                      },
                                    },
                                    [
                                      _c(
                                        "nav",
                                        {
                                          staticClass:
                                            "emd-nav-list _direction_column _hoverble",
                                        },
                                        [
                                          _c("ul", [
                                            _vm.showResendButton
                                              ? _c(
                                                  "li",
                                                  {
                                                    staticClass:
                                                      "emd-nav-list__item eu-no-padding eu-no-margin",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.openModal(
                                                          "RESEND_INVITE"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "emd-button",
                                                      {
                                                        staticClass: "eu-pa_3",
                                                        attrs: {
                                                          type: "link",
                                                          color: "primary",
                                                        },
                                                      },
                                                      [
                                                        _c("span", {
                                                          staticClass:
                                                            "uil uil-redo eu-pr_1",
                                                        }),
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "invite.resend-invite"
                                                            )
                                                          ) + " "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm.showRemoveButton
                                              ? _c(
                                                  "li",
                                                  {
                                                    staticClass:
                                                      "emd-nav-list__item eu-no-padding eu-no-margin",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.openModal(
                                                          "CANCEL_INVITE"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "emd-button",
                                                      {
                                                        staticClass: "eu-pa_3",
                                                        attrs: {
                                                          type: "link",
                                                          color: "danger",
                                                        },
                                                      },
                                                      [
                                                        _c("span", {
                                                          staticClass:
                                                            "uil uil-trash-alt eu-pr_1",
                                                        }),
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "invite.cancel-invite"
                                                            )
                                                          ) + " "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("emd-text", { attrs: { tag: "h2" } }, [
                    _vm._v(_vm._s(_vm.$t("invite.detail.info"))),
                  ]),
                ],
                1
              ),
              _vm.alert.show
                ? _c("invite-alert", {
                    attrs: { alert: _vm.alert },
                    on: {
                      cancel: function ($event) {
                        return _vm.$emit("resetAlert")
                      },
                    },
                  })
                : _vm._e(),
              _c("invite-detail-infos", { attrs: { invite: _vm.invite } }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.modalOpenned
        ? _c("modal-password", {
            attrs: { callback: _vm.actionInvite },
            on: { cancel: _vm.closeModal },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }